import { useCallback, useEffect, useState } from "react";
import { BIBlue, BIGrey, BIRed } from "../../assets/helpers";
import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  createFilterOptions,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import CompanySelectModal from "./CompanySelectModal";
import { Postrequestcall } from "../../request/Postrequest";
import {
  DELETE_USERS_WORKHISTORY,
  FETCH_COMPANIES,
  FETCH_COMPANIES_2,
  FETCH_COMPANIES_BY_NAME_NEW,
  FETCH_ROLES,
  FETCH_TRADES,
  FETCH_USERS_COMPANIES,
  FETCH_PROJECT_COMPANY_ROLES,
  SAVE_COMPANIES,
  SAVE_ROLE,
  SAVE_TRADES,
  SAVE_USER_COMPANIES,
  SAVE_USER_WORK_HISTORY,
  FETCH_USERS_WORK_HISTORY2,
  FETCH_PROJECTS_PICTURES,
  SAVE_FOLLOW_ENTITIES
} from "../../constant/Apipath";
import Removeduplicates from "./Removeduplicate";
import UseDebounce from "./UseDebounce";
import moment from "moment";
import PromptModal from "./PromptModal";
import {
  setProjectimages,
  setSelectedProjectdata,
  setShowaddexperience,
  setShowaddproject,
  setShowalert,
  setShowmapmodal
} from "../../redux/actions/actions";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import DeleteIcon from "@mui/icons-material/Delete";
import Addproducts from "../profile/Addproducts";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { English } from "../../constant/EnglishFallback";
import { Error } from "@mui/icons-material";
import BuildIdEvent from "../../common/BuildIdEvent";

const filter = createFilterOptions();

export default function Addexperience() {
  const { selectedCompany, loginData, selectedProject, showAddexperience, multiLanguageData } =
    useSelector((state) => state?.main);

  const [information, setInformation] = useState({
    startDate: null,
    endDate: null,
    description: "",
    present: false,
    includeResume: true,
    projectName: "",
    projectId: 0,
    imgUrl: "",
    siteName: "",
    address: "",
    latitude: null,
    longitude: null
  });

  const [openStartdate, setOpenstartdate] = useState(false);
  const [openEnddate, setOpenenddate] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [discardModal, setDiscardModal] = useState(false);
  const [allCompanies, seAllCompanies] = useState([]);
  const [companyList, setCompanylist] = useState([]);
  const [company, setCompany] = useState({ companyId: 0, companyName: "" });
  const [openCompanyModal, setOpenCompanyModal] = useState(false);
  const [selectCompany, setSelectcompany] = useState(false);
  const [companyRoles, setCompanyroles] = useState([]);
  const [companyRole, setCompnayrole] = useState({
    companyRoleid: 0,
    companyRolename: ""
  });
  const [selectCompanyRole, setSelectcompanyrole] = useState(false);
  const [roles, setRoles] = useState([]);
  const [role, setRole] = useState({ roleId: 0, roleName: "" });
  const [selectRole, setSelectrole] = useState(false);
  const [trades, setTrades] = useState([]);
  const [trade, setTrade] = useState({ tradeId: 0, tradeName: "" });
  const [selectTrade, setSelectTrade] = useState(false);
  const [companyStartDateNew, setCompanyStartDateNew] = useState(null);
  const [companyEndDateNew, setCompanyEndDateNew] = useState(null);
  const [updateModal, setUpdateModal] = useState(null);
  const [showDeleteAlertModal, setShowDeleteAlertModal] = useState(false);
  const [showProducts, setShowproducts] = useState(false);
  const [selectedProducts, setSelectedproducts] = useState([]);
  const [updateModalBody, setUpdateModalBody] = useState(null);
  const [loader, setLoader] = useState(false);

  const buildIdEvent = BuildIdEvent();

  const {
    TEXT_CHANGE_END_DATE = English?.AddExperience?.TEXT_CHANGE_END_DATE,
    TEXT_START_DATE_END_DATE_TITLE = English?.AddExperience?.TEXT_START_DATE_END_DATE_TITLE,
    TEXT_START_DATE_OR_UNCHECKED_PRESENT = English?.AddExperience
      ?.TEXT_START_DATE_OR_UNCHECKED_PRESENT,
    TEXT_ROLE_NOT_PRESENT = English?.AddExperience?.TEXT_ROLE_NOT_PRESENT,
    TEXT_SELECT_START_DATE = English?.AddExperience?.TEXT_SELECT_START_DATE,
    TEXT_OUTSIDE_TIMEFRAME_1 = English?.AddExperience?.TEXT_OUTSIDE_TIMEFRAME_1,
    TEXT_UPDATE_TIMEFRAME_2 = English?.AddExperience?.TEXT_UPDATE_TIMEFRAME_2,
    TEXT_PROJECT_TIMEFRAME_1 = English?.AddExperience?.TEXT_PROJECT_TIMEFRAME_1,
    TEXT_CORRECT_TIMEFRAME_2 = English?.AddExperience?.TEXT_CORRECT_TIMEFRAME_2,
    BUTTON_CANCEL = English?.AddExperience?.BUTTON_CANCEL,
    TEXT_UPDATE = English?.AddExperience?.TEXT_UPDATE,
    TEXT_PROMPT_DELETE_EXPERIENCE = English?.AddExperience?.TEXT_PROMPT_DELETE_EXPERIENCE,
    TEXT_PROMPT_DESC = English?.AddExperience?.TEXT_PROMPT_DESC,
    BUTTON_MODAL_DELETE_YES = English?.AddExperience?.BUTTON_MODAL_DELETE_YES,
    BUTTON_MODAL_DELETE_NO = English?.AddExperience?.BUTTON_MODAL_DELETE_NO,
    TEXT_DISCARD_CHANGES = English?.AddExperience?.TEXT_DISCARD_CHANGES,
    TEXT_WANT_TO_LEAVE_PAGE = English?.AddExperience?.TEXT_WANT_TO_LEAVE_PAGE,
    BUTTON_DISCARD = English?.AddExperience?.BUTTON_DISCARD,
    BUTTON_GOBACK = English?.AddExperience?.BUTTON_GOBACK,
    TEXT_EDIT_EXPERIENCE_PROFILE = English?.AddExperience?.TEXT_EDIT_EXPERIENCE_PROFILE,
    TEXT_ADD_EXPERIENCE_PROFILE = English?.AddExperience?.TEXT_ADD_EXPERIENCE_PROFILE,
    TEXT_SITE_PROJECT = English?.AddExperience?.TEXT_SITE_PROJECT,
    TEXT_MY_INFORMATION = English?.AddExperience?.TEXT_MY_INFORMATION,
    TEXT_COMPANY = English?.AddExperience?.TEXT_COMPANY,
    TEXT_START_DATE = English?.AddExperience?.TEXT_START_DATE,
    TEXT_MONTH_YEAR = English?.AddExperience?.TEXT_MONTH_YEAR,
    TEXT_COMPANY_ROLE = English?.AddExperience?.TEXT_COMPANY_ROLE,
    TEXT_END_DATE = English?.AddExperience?.TEXT_END_DATE,
    BUTTON_ADD = English?.AddExperience?.BUTTON_ADD,
    TEXT_TITLE_ROLE = English?.AddExperience?.TEXT_TITLE_ROLE,
    TEXT_TRADE = English?.AddExperience?.TEXT_TRADE,
    TEXT_LABEL_DESCRIPTION = English?.AddExperience?.TEXT_LABEL_DESCRIPTION,
    TEXT_PRESENT = English?.AddExperience?.TEXT_PRESENT,
    TEXT_PRODUCTS = English?.AddExperience?.TEXT_PRODUCTS,
    TEXT_MATERIAL_INSTRUCTION = English?.AddExperience?.TEXT_MATERIAL_INSTRUCTION,
    TEXT_THIS_INFORMATION_CAN = English?.AddExperience?.TEXT_THIS_INFORMATION_CAN,
    TEXT_PRODUCTS_IN_PROJECT = English?.AddExperience?.TEXT_PRODUCTS_IN_PROJECT,
    TEXT_NO_LOCATION_SITE_ALERT_IN_PROJECT = English?.AddExperience
      ?.TEXT_NO_LOCATION_SITE_ALERT_IN_PROJECT
  } = multiLanguageData?.AddExperience || {};

  useEffect(() => {
    if (showAddexperience === true) {
      //getCompanies();
      getFetchUserCompanies();
      getInformation();
    }
    return () => {
      setCompnayrole({
        companyRoleid: 0,
        companyRolename: ""
      });
      setSelectedproducts([]);
      setRole({
        roleId: 0,
        roleName: ""
      });
      setTrade({
        tradeId: 0,
        tradeName: ""
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAddexperience]);

  const getInformation = async () => {
    if (selectedProject?.type === "add") {
      setCompany({
        companyId: selectedCompany?.companyId,
        companyName: selectedCompany?.companyName
      });
      setSelectedproducts([]);
    } else {
      setCompnayrole({
        companyRoleid: selectedProject?.projectCompanyRoleId ?? 0,
        companyRolename: selectedProject?.projectCompanyRoleName ?? ""
      });
      setCompany({
        companyId: selectedCompany?.companyId,
        companyName: selectedCompany?.companyName
      });
      setTrade({
        tradeId: selectedProject?.tradeId,
        tradeName: selectedProject?.tradeName
      });
      setRole({
        roleId: selectedProject?.roleId,
        roleName: selectedProject?.roleName
      });
      getSelectedproducts();
    }
    setInformation({
      ...information,
      projectName: selectedProject?.projectName,
      projectId: selectedProject?.projectId,
      present: selectedProject?.present,
      imgUrl: selectedProject?.mainPictureUrl ?? (await fetchProjectimage()),
      siteName: selectedProject?.siteName,
      address: selectedProject?.address,
      latitude: selectedProject?.latitude,
      longitude: selectedProject?.longitude,
      description: selectedProject?.type === "edit" ? selectedProject?.description : "",
      startDate:
        selectedProject?.type === "edit"
          ? selectedProject?.startDate === null
            ? null
            : dayjs(selectedProject?.startDate).format("YYYY-MM-DD")
          : null,
      endDate:
        selectedProject?.type === "edit"
          ? selectedProject?.endDate === null
            ? null
            : dayjs(selectedProject?.endDate).format("YYYY-MM-DD")
          : null
    });
  };

  const fetchProjectimage = async () => {
    try {
      let imageObj = {
        SearchList: [{ projectId: selectedProject?.projectId }]
      };
      const imagesRes = await Postrequestcall(
        FETCH_PROJECTS_PICTURES,
        imageObj,
        loginData?.accessToken
      );
      if (imagesRes.status === 201) {
        const imagesResData = imagesRes?.data?.data ?? [];
        return imagesResData?.length > 0 ? imagesResData?.[0].thumbImageUrl : PlaceholderImg;
      } else {
        return PlaceholderImg;
      }
    } catch (error) {}
  };

  // Get product list
  const getSelectedproducts = async () => {
    const getObject = {
      PageNr: 1,
      FullSearch: "",
      IncludeRecordNr: false,
      NrOfRecPerPage: 20,
      UserId: loginData?.userInformation?.UserId,
      SearchList: [{ UserId: loginData?.userInformation?.UserId }],
      SortList: [{ FieldName: "id", Direction: "DESC" }]
    };
    const getResponse = await Postrequestcall(
      FETCH_USERS_WORK_HISTORY2,
      getObject,
      loginData?.accessToken
    );
    if (getResponse.status === 201) {
      const userExperienceProductList = getResponse?.data?.data?.userExperienceProductList ?? [];
      const productsData = userExperienceProductList
        .filter((item) => item?.userExperienceId === selectedProject?.id)
        .map((item) => ({ ...item, selected: true }));
      // If length is empty
      if (productsData?.length > 0) {
        setSelectedproducts(productsData);
      }
    }
  };

  // Company Roles
  const debouncedCompany = UseDebounce(company?.companyName, 400);
  useEffect(() => {
    if (debouncedCompany) getCompanies(debouncedCompany);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedCompany]);

  // Company list
  const getCompanies = useCallback(async (searchValue) => {
    try {
      // OLD API: FETCH_COMPANIES_2 (commented, do not delete)
      // let getObject = {
      //   UserId: loginData?.userInformation?.UserId ?? 0,
      //   SearchString: searchValue || "",
      //   PageNumber: 1,
      //   PageSize: 50,
      //   Manufacturer: false,
      //   Id: 0
      // };
      // const getResponse = await Postrequestcall(FETCH_COMPANIES_2, getObject, loginData?.accessToken);

      // NEW API: FETCH_COMPANIES_BY_NAME_NEW (active)
      let getObject = {
        PageNr: 1,
        NrOfRecPerPage: 50,
        FullSearch: searchValue || "",
        UserId: loginData?.userInformation?.UserId ?? 0,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [{}],
        SortList: [
          { FieldName: "Verified", Direction: "DESC" },
          { FieldName: "Name", Direction: "ASC" }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_COMPANIES_BY_NAME_NEW,
        getObject,
        loginData?.accessToken
      );
      if (getResponse?.data?.data) {
        let getUpdatedlist = Removeduplicates(getResponse?.data?.data || [], "name");
        getUpdatedlist = getUpdatedlist.map((item) => {
          return {
            ...item,
            id: item?.id,
            name: item?.name
          };
        });
        setCompanies(getUpdatedlist);
      }
    } catch (error) {
      console.log("getCompanies-> Error When Fetching Companies: ", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginData?.accessToken, loginData?.userInformation?.UserId]);

  const getFetchUserCompanies = async () => {
    try {
      const userCompanyObj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 0,
        SearchList: [{ UserId: loginData?.userInformation?.UserId }]
      };
      const getResponse = await Postrequestcall(
        FETCH_USERS_COMPANIES,
        userCompanyObj,
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        seAllCompanies(getResponse?.data?.data);
      }
    } catch (error) {
      console.log("getFetchUserCompanies-> Error When Fetching User Companies: ", error);
    }
  };

  const onCompanychange = async (e) => {
    const regex = /^[a-zA-Z0-9 ]*$/;
    let value = e.target.value.replace(/^[^A-Za-z0-9]+/, ""); // Clean input

    if (regex.test(value)) {
      setSelectcompany(value !== "");
      setCompany({
        ...company,
        companyName: value
      });
    }
  };

  const onCompanyselect = (event, newValue) => {
    setSelectcompany(false);
    if (newValue?.recordStatusId === 3) {
      alert("This company is reported");
      return;
    }
    if (newValue?.inputValue) {
      let getObj = {
        companyId: 0,
        companyName: newValue?.inputValue
      };
      setCompany(getObj);
    } else if (newValue === null) {
      setCompany({
        ...company,
        companyId: 0,
        companyName: ""
      });
    } else {
      setCompany({
        ...company,
        companyId: newValue?.id,
        companyName: newValue?.name
      });
    }
  };

  const onClearcompany = () => {
    setCompany({
      ...company,
      companyId: 0,
      companyName: ""
    });
  };

  // Company Roles
  const debouncedCompanyRole = UseDebounce(companyRole?.companyRolename, 200);
  useEffect(() => {
    if (debouncedCompanyRole) fetchCompnayroles(debouncedCompanyRole);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedCompanyRole]);

  const fetchCompnayroles = useCallback(async (searchValue) => {
    try {
      let getRoleobj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [{ Name: searchValue }],
        SortList: [{ FieldName: "Name", Direction: "ASC" }]
      };
      let getResponse = await Postrequestcall(
        FETCH_PROJECT_COMPANY_ROLES,
        getRoleobj,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        let getUpdatedlist = Removeduplicates(getResponse?.data?.data, "name");
        getUpdatedlist = getUpdatedlist.map((item) => {
          return {
            ...item,
            companyRolename: item?.name
          };
        });
        if (getUpdatedlist?.length > 0) {
          setCompanyroles(getUpdatedlist);
        }
      }
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCompanyrolechange = async (e) => {
    let cleanedInput = e.target.value.replace(/^[^A-Za-z0-9]+/, "");

    if (cleanedInput !== "") {
      setSelectcompanyrole(true);
    } else {
      setSelectcompanyrole(false);
    }

    setCompnayrole({
      ...companyRole,
      companyRolename: cleanedInput
    });
  };

  const onCompanyroleselect = (event, newValue) => {
    setSelectcompanyrole(false);
    if (newValue?.inputValue) {
      let getObj = {
        companyRoleid: 0,
        companyRolename: newValue?.inputValue
      };
      setCompnayrole(getObj);
    } else if (newValue === null) {
      setCompnayrole({
        ...companyRole,
        companyRoleid: 0,
        companyRolename: ""
      });
    } else {
      setCompnayrole({
        companyRoleid: newValue?.id,
        companyRolename: newValue?.name
      });
    }
  };

  const onClearcompanyrole = (e) => {
    setSelectcompanyrole(false);
    setCompnayrole({
      ...companyRole,
      companyRoleid: 0,
      companyRolename: ""
    });
  };

  // Roles
  const debouncedRole = UseDebounce(role?.roleName, 200);
  useEffect(() => {
    if (debouncedRole) fetchRoles(debouncedRole);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedRole]);

  const fetchRoles = useCallback(async (searchValue) => {
    try {
      let getRole = {
        IncludeRecordNr: true,
        NrOfRecPerPage: 0,
        SearchList: [{ name: searchValue, manufacturer: false }],
        SortList: [{ FieldName: "Name", Direction: "ASC" }]
      };
      let getResponse = await Postrequestcall(FETCH_ROLES, getRole, loginData?.accessToken);
      if (getResponse?.status === 201) {
        let getUpdatedlist = Removeduplicates(getResponse?.data?.data, "name");
        getUpdatedlist = getUpdatedlist.map((item) => {
          return {
            ...item,
            roleName: item?.name
          };
        });
        if (getUpdatedlist?.length > 0) {
          setRoles(getUpdatedlist);
        }
      }
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRolechange = async (e) => {
    let value = e.target.value;
    const regex = /^[a-zA-Z0-9 ]*$/;

    value = value.replace(/^[^A-Za-z0-9]+/, ""); // Clean leading non-alphanumerics

    if (regex.test(value)) {
      if (value !== "") {
        setSelectrole(true);
      } else {
        setSelectrole(false);
      }
      setRole({
        ...role,
        roleName: value
      });
    }
  };

  const onRoleselect = (event, newValue) => {
    setSelectrole(false);
    if (newValue?.inputValue) {
      let getObj = {
        roleId: 0,
        roleName: newValue?.inputValue
      };
      setRole(getObj);
    } else if (newValue === null) {
      setRole({
        ...role,
        roleId: 0,
        roleName: ""
      });
    } else {
      setRole({
        ...role,
        roleId: newValue?.id,
        roleName: newValue?.name
      });
    }
  };

  const onClearRole = () => {
    setSelectrole(false);
    setRole({
      ...role,
      roleId: 0,
      roleName: ""
    });
  };

  // Trades
  const debouncedTrade = UseDebounce(trade?.tradeName, 200);
  useEffect(() => {
    if (debouncedTrade) fetchTrades(debouncedTrade);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedTrade]);

  const fetchTrades = useCallback(async (searchValue) => {
    try {
      let getRole = {
        IncludeRecordNr: true,
        NrOfRecPerPage: 0,
        SearchList: [{ name: searchValue, manufacturer: false }],
        SortList: [{ FieldName: "Name", Direction: "ASC" }]
      };
      let getResponse = await Postrequestcall(FETCH_TRADES, getRole, loginData?.accessToken);
      if (getResponse?.status === 200) {
        let getUpdatedlist = Removeduplicates(getResponse?.data?.data, "name");
        getUpdatedlist = getUpdatedlist.map((item) => {
          return {
            ...item,
            tradeName: item?.name
          };
        });
        if (getUpdatedlist?.length > 0) {
          setTrades(getUpdatedlist);
        }
      }
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTradechange = async (e) => {
    let value = e.target.value;
    // Remove leading non-alphanumeric characters
    value = value.replace(/^[^A-Za-z0-9]+/, "");
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (regex.test(value)) {
      if (value !== "") {
        setSelectTrade(true);
      } else {
        setSelectTrade(false);
      }
      setTrade({
        ...trade,
        tradeName: value
      });
    }
  };

  const onTradeselect = (event, newValue) => {
    setSelectTrade(false);
    if (newValue?.inputValue) {
      let getObj = {
        tradeId: 0,
        tradeName: newValue?.inputValue
      };
      setTrade(getObj);
    } else if (newValue === null) {
      setTrade({
        ...trade,
        tradeId: 0,
        tradeName: ""
      });
    } else {
      setTrade({
        ...trade,
        tradeId: newValue?.id,
        tradeName: newValue?.name
      });
    }
  };

  const onClearTrade = () => {
    setSelectTrade(false);
    setTrade({
      ...trade,
      tradeId: 0,
      tradeName: ""
    });
  };

  const onInformationchange = (e) => {
    const { name, value } = e.target;
    // Apply the regex to remove leading non-alphanumeric characters
    const sanitizedValue = value.replace(/^[^A-Za-z0-9]+/, "");
    setInformation({
      ...information,
      [name]: sanitizedValue
    });
  };

  const onPresentchange = (e) => {
    setInformation({
      ...information,
      [e.target.name]: e.target.checked,
      endDate: null
    });
  };

  const onStartdatechange = (date) => {
    setInformation({
      ...information,
      startDate: date
    });
  };

  const onEnddatechange = (date) => {
    setInformation({
      ...information,
      endDate: date
    });
  };

  const onSaveprofile = async () => {
    try {
      let roleId = role?.roleId ?? 0;
      let companyRoleId = companyRole?.companyRoleid ?? 0;
      let tradeId = trade?.tradeId ?? 0;
      if (information?.startDate === information?.endDate && information?.startDate != null) {
        let alertObj = {
          showAlert: true,
          title: "",
          text: TEXT_CHANGE_END_DATE
        };
        dispatch(setShowalert(alertObj));
        return;
      } else if (
        !information?.present &&
        information?.startDate &&
        information?.endDate &&
        dayjs(information?.startDate).format("YYYY-MM-DD") >
          dayjs(information?.endDate).format("YYYY-MM-DD")
      ) {
        let alertObj = {
          showAlert: true,
          title: "",
          text: TEXT_START_DATE_END_DATE_TITLE
        };
        dispatch(setShowalert(alertObj));
        return;
      } else if (information?.present && !information?.startDate) {
        let alertObj = {
          showAlert: true,
          title: "",
          text: TEXT_START_DATE_OR_UNCHECKED_PRESENT
        };
        dispatch(setShowalert(alertObj));
        return;
      }
      if (roleId === 0 && role?.roleName?.length > 1) {
        roleId = await saveSelectedItem(role?.roleName, "role");
      }
      if (trade?.tradeId === 0 && trade?.tradeName?.length > 1) {
        tradeId = await saveNewTrade(trade?.tradeName);
      }
      if (Number(companyRole?.companyRoleid) === 0 && companyRole?.companyRolename?.length > 1) {
        let alertObj = {
          showAlert: true,
          title: "",
          text: TEXT_ROLE_NOT_PRESENT
        };
        dispatch(setShowalert(alertObj));
        return;
      }
      if (company?.companyId === 0 && company?.companyName?.trim() !== "") {
        let getCompanyId = await saveSelectedItem(company?.companyName, "company");
        await formatTimeframe(getCompanyId, roleId, tradeId, companyRoleId);
      } else {
        await formatTimeframe(company?.companyId, roleId, tradeId, companyRoleId);
      }
    } catch (err) {
      console.log("onSaveprofile-> Error When Saving On Profile: ", err);
    } finally {
    }
  };

  const formatTimeframe = async (companyId, roleId, tradeId, companyRoleId) => {
    try {
      const comp = allCompanies.filter((comp) => comp.companyId === company?.companyId)?.pop();

      if (comp) {
        let companyStartDate = comp?.startDate
          ? moment(comp?.startDate).format("YYYY-MM-DD")
          : null;
        let companyEndDate = comp?.endDate ? moment(comp?.endDate).format("YYYY-MM-DD") : null;

        // If company endDate is null, treat company as "present" (ongoing).
        // A null companyEndDate means the company has no closed end — it's still active.
        const companyIsPresent = !companyEndDate;

        let newStartDate = information?.startDate
          ? dayjs(information?.startDate).format("YYYY-MM-DD")
          : null;
        let newEndDate = information?.endDate
          ? dayjs(information?.endDate).format("YYYY-MM-DD")
          : null;

        // Guard: project start date is required when there's a company start date
        if (!newStartDate && newEndDate) {
          let alertObj = {
            showAlert: true,
            title: "",
            text: TEXT_SELECT_START_DATE
          };
          dispatch(setShowalert(alertObj));
          return;
        }

        // ─── Case 1: Company has no dates at all ───────────────────────────────
        // Bootstrap the company with project dates, then save directly.
        if (!companyStartDate && !companyEndDate && newStartDate) {
          const bootstrapCompanyStart = newStartDate;
          const bootstrapCompanyEnd = newEndDate; // may be null (project is present)
          setCompanyStartDateNew(bootstrapCompanyStart);
          setCompanyEndDateNew(bootstrapCompanyEnd);
          let obj = {
            data: comp,
            companyStartDateNew: bootstrapCompanyStart,
            companyEndDateNew: bootstrapCompanyEnd,
            currentCompany: information?.present,
            onUpdatePressed: "onUpdatePressed"
          };
          onUpdatePressed(obj);
          return;
        }

        // ─── Case 2: Company is present/ongoing (companyEndDate is null) ───────
        // The company is still active, so it covers all dates from companyStartDate onward.
        // A project is valid as long as its start date is >= companyStartDate.
        // No "out of frame" warning is shown when the company is present.
        if (companyIsPresent) {
          if (!companyStartDate) {
            // Company has no start date and no end date — fully unconstrained, just save.
            await saveWorkHistory(companyId, roleId, tradeId, companyRoleId);
            return;
          }

          if (newStartDate && newStartDate < companyStartDate) {
            // Project starts before the company — expand company start date backward.
            const updatedCompanyStart = newStartDate;
            setCompanyStartDateNew(updatedCompanyStart);
            setCompanyEndDateNew(null); // keep company as present
            setUpdateModal("isProjectOutOfFrame");
            setUpdateModalBody(
              `${TEXT_OUTSIDE_TIMEFRAME_1} ${company?.companyName}. ${TEXT_UPDATE_TIMEFRAME_2}`
            );
            return;
          }
          // Project start is within or after companyStartDate and company is present → valid.
          await saveWorkHistory(companyId, roleId, tradeId, companyRoleId);
          return;
        }
        // ─── Case 3: Company has a defined start AND end date ─────────────────
        // companyStartDate and companyEndDate are both set here.
        // Project has no start date — cannot validate, block save.
        if (!newStartDate) {
          let alertObj = {
            showAlert: true,
            title: "",
            text: TEXT_SELECT_START_DATE
          };
          dispatch(setShowalert(alertObj));
          return;
        }
        // Project falls entirely BEFORE the company window → hard block.
        if (newEndDate && newEndDate < companyStartDate) {
          let alertObj = {
            showAlert: true,
            title: "",
            text: `${TEXT_PROJECT_TIMEFRAME_1} ${company?.companyName} ${TEXT_CORRECT_TIMEFRAME_2}`
          };
          dispatch(setShowalert(alertObj));
          return;
        }
        // Project starts entirely AFTER the company end → hard block.
        if (newStartDate > companyEndDate) {
          let alertObj = {
            showAlert: true,
            title: "",
            text: `${TEXT_PROJECT_TIMEFRAME_1} ${company?.companyName} ${TEXT_CORRECT_TIMEFRAME_2}`
          };
          dispatch(setShowalert(alertObj));
          return;
        }
        // Determine if company dates need to be expanded to fit the project.
        let updatedCompanyStart = companyStartDate;
        let updatedCompanyEnd = companyEndDate;
        let needsExpansion = false;

        if (newStartDate < companyStartDate) {
          updatedCompanyStart = newStartDate;
          needsExpansion = true;
        }

        // Project end is null (present) or exceeds company end → expand company end.
        if (!newEndDate || newEndDate > companyEndDate) {
          updatedCompanyEnd = newEndDate ?? null; // null keeps it as "present"
          needsExpansion = true;
        }

        if (needsExpansion) {
          setCompanyStartDateNew(updatedCompanyStart);
          setCompanyEndDateNew(updatedCompanyEnd);
          setUpdateModal("isProjectOutOfFrame");
          setUpdateModalBody(
            `${TEXT_OUTSIDE_TIMEFRAME_1} ${company?.companyName}. ${TEXT_UPDATE_TIMEFRAME_2}`
          );
          return;
        }
        // Project fits entirely within the company window → save directly.
        await saveWorkHistory(companyId, roleId, tradeId, companyRoleId);
      } else {
        // No matching company in user's list — save directly.
        await saveWorkHistory(companyId, roleId, tradeId, companyRoleId);
      }
    } catch (error) {
      console.log("formatTimeframe-> Error: ", error);
    }
  };

  const saveNewTrade = async (name) => {
    try {
      const formData = new FormData();
      formData.append("Id", 0);
      formData.append("Name", name);
      formData.append("TradePictureUrl", "");
      formData.append("Description", "");
      formData.append("ModifiedBy", loginData?.userInformation?.UserId);
      let getResponse = await Postrequestcall(SAVE_TRADES, formData, loginData?.accessToken, true);
      if (getResponse.status === 201) {
        setTrade({
          ...trade,
          tradeId: getResponse.data.data
        });
        return getResponse.data.data;
      }
    } catch (error) {
      console.log("saveNewTrade-> Error While Saving New Trade: ", error);
    }
  };

  const saveSelectedItem = async (name, option) => {
    try {
      if (option === "company") {
        const mainObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: true
        };
        const saveObject = {
          ...mainObj,
          SaveList: [
            {
              Id: 0,
              Name: name,
              ModifiedBy: loginData?.userInformation?.UserId,
              RecordStatusId: 1,
              Manufacturer: false
            }
          ]
        };
        const getResponse = await Postrequestcall(
          SAVE_COMPANIES,
          saveObject,
          loginData?.accessToken
        );
        return getResponse?.data?.data[0]?.objData?.id;
      } else {
        const roleObj = {
          Id: 0,
          Name: name,
          CreatedBy: loginData?.userInformation?.UserId,
          DateCreated: moment().format(),
          ModifiedBy: loginData?.userInformation?.UserId,
          DateModified: moment().format()
        };
        const getRoleresponse = await Postrequestcall(SAVE_ROLE, roleObj, loginData?.accessToken);
        if (getRoleresponse.status === 201) {
          let roleId = getRoleresponse.data.data;
          setRole({
            ...role,
            roleId: roleId
          });
        }
      }
    } catch (err) {
      console.log("saveSelectedItem-> Error While Saving Companie: ", err);
    }
  };

  const onUpdatePressed = async (params) => {
    try {
      const companyObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: params?.data?.id,
            UserId: loginData?.userInformation?.UserId,
            RoleId: params?.data?.roleId,
            CompanyId: params?.data?.companyId,
            StartDate: companyStartDateNew
              ? moment(companyStartDateNew).format("YYYY-MM-DD")
              : null,
            endDate:
              information?.present === true
                ? null
                : companyEndDateNew && companyEndDateNew !== "Invalid date"
                  ? moment(companyEndDateNew).format("YYYY-MM-DD")
                  : null,
            ModifiedBy: loginData?.userInformation?.UserId,
            CurrentCompany: params.currentCompany,
            IncludeInResume: params?.data?.includeResume ? params?.data?.includeResume : false,
            Description: params?.data?.description
          }
        ]
      };
      const getResponse = await Postrequestcall(
        SAVE_USER_COMPANIES,
        companyObj,
        loginData?.accessToken
      );
      if (getResponse?.data?.data[0]?.objData?.id !== "") {
        await saveWorkHistory(
          company?.companyId,
          role?.roleId,
          trade?.tradeId,
          companyRole?.companyRoleid
        );
      }
    } catch (error) {
      console.log("onUpdatePressed-> Error When Saving User Companie: " + error);
    }
  };

  const saveWorkHistory = async (companyId, roleId, tradeId, companyRoleId) => {
    setLoader(true);
    try {
      const getSelected = selectedProducts.map((product) => product?.productId).join(",");
      const getObj = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        UserId: loginData?.userInformation?.UserId,
        SaveList: [
          {
            Id: selectedProject?.type === "edit" ? selectedProject?.id : 0,
            UserId: loginData?.userInformation?.UserId,
            StartDate:
              information?.startDate && information?.startDate !== ""
                ? dayjs(information?.startDate).format("YYYY-MM-DD")
                : null,
            EndDate: information?.present
              ? null
              : information?.endDate && information?.endDate !== ""
                ? dayjs(information?.endDate).format("YYYY-MM-DD")
                : null,
            Present: information?.present,
            IncludeInResume: information?.includeResume,
            ProjectId: information?.projectId,
            description: information?.description,
            ProjectCompanyRoleId: companyRoleId,
            CompanyId: companyId ?? 0,
            RoleId: roleId ?? 0,
            TradeId: tradeId ?? 0,
            isFollowing: true,
            ProductIdList: getSelected.length !== 0 ? getSelected : "",
            IsFirstTime: false
          }
        ]
      };
      let getResponse = await Postrequestcall(
        SAVE_USER_WORK_HISTORY,
        getObj,
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        const getData = getResponse?.data?.data[0]?.objData;
        const chatGroupId = getData?.chatGroupId || 0;
        const chatGroupName = getData?.siteName || "";
        // Sending Announcement Messages in Chat Group
        await triggerSendAnnouncementMessage(chatGroupId, chatGroupName);
        await onRefreshpage();
      }
    } catch (error) {
      console.log("saveWorkHistory-> Error While Saving User Work history: ", error);
    } finally {
      setLoader(false);
    }
  };

  const getAnnouncementMessageToBeSent = (FirstName, chatGroupName) => {
    const message = `${FirstName} has joined the ${chatGroupName} group chat. Welcome aboard! Feel free to ask questions, share updates, or coordinate with your crew here.`;
    return message;
  };

  const triggerSendAnnouncementMessage = async (chatGroupId, chatGroupName) => {
    try {
      const message = getAnnouncementMessageToBeSent(
        loginData?.userInformation?.FirstName,
        chatGroupName
      );
      let getMessagesText = [
        Number(loginData?.userInformation?.UserId),
        loginData?.userInformation?.FirstName,
        loginData?.userInformation?.LastName,
        loginData?.pictureUrl,
        chatGroupId,
        message,
        6, // MessageType: 6 for Announcement
        loginData?.ChatLanguage
      ];
      if (message.trim() !== "") {
        await buildIdEvent.sendMessage(getMessagesText);
      }
    } catch (error) {
      console.log(
        "triggerSendAnnouncementMessage-> Error While Sending Announcement Message: ",
        error
      );
    }
  };

  const onRefreshpage = async () => {
    dispatch(setShowaddexperience(false));
    dispatch(setShowaddproject(false));
    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    dispatch(setShowmapmodal(mapModal));
    dispatch(setProjectimages([]));
    if (selectedProject?.type === "edit") {
      let getObj = { ...selectedProject, type: "update" };
      dispatch(setSelectedProjectdata(getObj)); // Store the project data for edit
    } else {
      if (selectedProject?.from === "project-detail") {
        // From project detail page When we click Add to profile
        await saveFollowEntities();
      } else if (selectedProject?.from === "company-detail") {
        dispatch(setSelectedProjectdata(null));
        return;
      } else if (selectedProject?.from === "select-option") {
      } else {
        navigate("/project/" + information.projectId);
      }
    }
  };

  const saveFollowEntities = async () => {
    try {
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: selectedProject?.followDetailsId,
            EntityTypeId: 24,
            EntityId: information.projectId,
            UserId: loginData?.userInformation?.UserId,
            IsFollowing: true,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      await Postrequestcall(SAVE_FOLLOW_ENTITIES, getObject, loginData?.accessToken);
      navigate(`/project/${information.projectId}`, { state: { refresh: new Date().getTime() } });
    } catch (error) {}
  };

  const onCloseexperience = () => {
    setDiscardModal(true);
  };

  const handleDeleteButtonClick = async () => {
    setLoader(true);
    try {
      setShowDeleteAlertModal(false);
      let deleteObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: selectedProject?.id ?? 0,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      let getResponse = await Postrequestcall(
        DELETE_USERS_WORKHISTORY,
        deleteObj,
        loginData?.accessToken
      );

      if (getResponse?.status === 201) {
        let getObj = { ...selectedProject, type: "delete" };
        dispatch(setSelectedProjectdata(getObj)); // Store the project data
        dispatch(setShowaddexperience(false));
      }
    } catch (error) {
      console.log("handleDeleteButtonClick-> Error While Deleting Experience: ", error);
    } finally {
      setLoader(false);
    }
  };

  const onModalClose = () => {
    // Close all
    setDiscardModal(false);
    dispatch(setShowaddexperience(false));
    dispatch(setShowaddproject(false));
    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    dispatch(setShowmapmodal(mapModal));
  };

  const onShowproducts = () => {
    setShowproducts(true);
  };

  const onProductClick = (value) => {
    let getUpdatedlist = selectedProducts.filter((item) => item?.productId !== value?.productId);
    setSelectedproducts(getUpdatedlist ?? []);
  };

  const handleTogglePicker = (e, picker) => {
    e.stopPropagation();
    e.preventDefault();
    if (picker === "end" && !information.present) {
      setOpenenddate(openEnddate ? false : true);
    } else if (picker === "start") {
      setOpenstartdate(openStartdate ? false : true);
    }
  };

  const handleClear = (e, picker) => {
    e.preventDefault();
    e.stopPropagation();
    if (picker === "start") {
      setOpenstartdate(false);
      setInformation({ ...information, startDate: null });
    }
    if (picker === "end") {
      setOpenenddate(false);
      setInformation({ ...information, endDate: null });
    }
  };

  const handleErrorClick = () => {
    let alertObj = {
      showAlert: true,
      title: "",
      text: TEXT_NO_LOCATION_SITE_ALERT_IN_PROJECT
    };
    dispatch(setShowalert(alertObj));
  };

  return (
    <>
      <PromptModal
        isOpen={updateModal !== null}
        onClose={() => {
          setUpdateModal(null);
        }}
        title={""}
        desc={updateModalBody}
        redButtonText={BUTTON_CANCEL}
        onRedButtonClick={() => {
          setUpdateModal(null);
        }}
        blueButtonText={TEXT_UPDATE}
        onBlueButtonClick={async () => {
          let comp = allCompanies.filter((comp) => comp.companyId === company?.companyId)?.pop();
          let obj = {
            data: comp,
            companyStartDateNew: companyStartDateNew,
            companyEndDateNew: companyEndDateNew,
            currentCompany: information?.present
          };
          onUpdatePressed(obj);
          setUpdateModal(null);
        }}
      />

      <PromptModal
        isOpen={showDeleteAlertModal}
        onClose={() => setShowDeleteAlertModal(false)}
        title={TEXT_PROMPT_DELETE_EXPERIENCE}
        desc={TEXT_PROMPT_DESC}
        redButtonText={BUTTON_MODAL_DELETE_YES}
        blueButtonTextFirst={BUTTON_MODAL_DELETE_NO}
        onRedButtonClick={handleDeleteButtonClick}
      />

      <PromptModal
        isOpen={discardModal}
        onClose={() => {
          setDiscardModal(false);
        }}
        title={TEXT_DISCARD_CHANGES}
        desc={TEXT_WANT_TO_LEAVE_PAGE}
        redButtonText={BUTTON_DISCARD}
        blueButtonTextFisrt={BUTTON_GOBACK}
        onRedButtonClick={() => onModalClose()}
      />

      <CompanySelectModal
        open={openCompanyModal}
        onClose={() => setOpenCompanyModal(false)}
        onSelect={(comp) => {
          if (comp?.recordStatusId === 3) {
            alert(comp?.manufacturer ? "This manufacturer is reported" : "This company is reported");
            return;
          }
          setCompany({
            companyId: comp?.id,
            companyName: comp?.name
          });
          setOpenCompanyModal(false);
        }}
        selectedId={company?.companyId}
        title="Select Company"
        placeholder="Search company..."
      />

      <Modal
        open={showAddexperience ?? false}
        onClose={() => onCloseexperience()}
        disableEnforceFocus
        disableAutoFocus
      >
        {loader ? (
          <Loader fullScreen={true} />
        ) : (
          <Box className="user-modal-responsive" overflow={"scroll"}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
              }}>
              <Typography className="add-title" style={{ margin: "0px" }}>
                {selectedProject?.type === "edit"
                  ? TEXT_EDIT_EXPERIENCE_PROFILE
                  : TEXT_ADD_EXPERIENCE_PROFILE}
              </Typography>
              <Stack direction={"row"}  sx={{ gap: 1, alignItems: "center" }}>
                <CloseIcon
                  style={{ color: "#083DB8", cursor: "pointer" }}
                  onClick={() => onCloseexperience()}
                />
                <SaveIcon
                  onClick={() => onSaveprofile()}
                  style={{ color: BIBlue, cursor: "pointer" }}
                />
                {selectedProject?.type === "edit" && (
                  <IconButton
                    onClick={() => setShowDeleteAlertModal(true)}
                    style={{ margin: "0px", padding: "0px" }}>
                    <DeleteIcon style={{ color: "red" }} />
                  </IconButton>
                )}
              </Stack>
            </Box>
            <Stack className="project-detail">
              <Typography sx={{ marginBottom: "10px" }}>{TEXT_SITE_PROJECT}</Typography>
              <Stack sx={{ gap: 1.5,  alignItems: "center", justifyContent: "space-between"  }} direction="row"  width="100%">
                {/* Left side: Image + Text */}
                <Stack direction="row" sx={{ gap: 1.5,  alignItems: "center"  }} >
                  <img
                    className="project-img"
                    src={information?.imgUrl ? information?.imgUrl : PlaceholderImg}
                    onError={(event) => (event.target.src = PlaceholderImg)}
                    alt="Project Detail"
                  />
                  <Stack>
                    <Typography sx={{ fontSize: "16px" }} className="project-name">
                      {information?.projectName}
                    </Typography>
                    <Typography sx={{color: "#8D8D8D",  fontSize: "14px" }}  className="project-sitename">
                      {information?.siteName}
                    </Typography>
                    <Typography sx={{color: "#8D8D8D",  fontSize: "14px" }}  className="project-address">
                      {information?.address
                        ? information.address
                        : information?.latitude || information?.longitude
                          ? `(${information.latitude}, ${information.longitude})`
                          : "No Location"}
                    </Typography>
                  </Stack>
                </Stack>

                {!information?.address && (!information?.latitude || !information?.longitude) && (
                  <IconButton sx={{ color: BIRed }} onClick={handleErrorClick}>
                    <Error />
                  </IconButton>
                )}
              </Stack>
            </Stack>
            <Typography className="exp-my-info">{TEXT_MY_INFORMATION}</Typography>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <TextField
                  fullWidth
                  label={TEXT_COMPANY}
                  value={company?.companyName || ""}
                  placeholder={selectedProject?.from === "experience" ? "" : "Select Company"}
                  disabled={selectedProject?.from === "experience"}
                  onClick={() => {
                    if (selectedProject?.from !== "experience") {
                      setOpenCompanyModal(true);
                    }
                  }}
                  onMouseDown={(e) => {
                    if (selectedProject?.from !== "experience") {
                      e.preventDefault();
                      setOpenCompanyModal(true);
                    }
                  }}
                  onFocus={(e) => {
                    if (selectedProject?.from !== "experience") {
                      e.target.blur();
                      setOpenCompanyModal(true);
                    }
                  }}
                  InputProps={{
                    readOnly: true,
                    endAdornment: company?.companyName && selectedProject?.from !== "experience" ? (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            onClearcompany();
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null
                  }}
                  inputProps={{
                    readOnly: true
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  slotProps={{
                    input: {
                      readOnly: true,
                      onClick: () => {
                        if (selectedProject?.from !== "experience") {
                          setOpenCompanyModal(true);
                        }
                      },
                      onMouseDown: (e) => {
                        if (selectedProject?.from !== "experience") {
                          e.preventDefault();
                          setOpenCompanyModal(true);
                        }
                      },
                      endAdornment: company?.companyName && selectedProject?.from !== "experience" ? (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              onClearcompany();
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : null
                    },
                    inputLabel: { shrink: true }
                  }}
                  sx={{
                    cursor: selectedProject?.from === "experience" ? "default" : "pointer",
                    "& input": { cursor: selectedProject?.from === "experience" ? "default" : "pointer" }
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    enableAccessibleFieldDOMStructure={false}
                    autoFocus={false}
                    yearsPerRow={3}
                    maxDate={dayjs()}
                    openTo="year"
                    value={information?.startDate ? dayjs(information.startDate) : null}
                    onChange={onStartdatechange}
                    open={openStartdate}
                    views={["year", "month"]} // Show only Month & Year
                    onOpen={() => setOpenstartdate(true)} // Prevent opening when disabled
                    onClose={() => setOpenstartdate(false)}
                    label={TEXT_START_DATE}
                    name="startDate"
                    format="MMM YYYY"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "medium",
                        error: false,
                        placeholder: TEXT_MONTH_YEAR,
                        InputLabelProps: { shrink: true },
                        onClick: () => setOpenstartdate(true),
                        onFocus: (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }
                      },
                      inputAdornment: {
                        position: "start"
                      },
                      openPickerButton: {
                        onClick: (e) => handleTogglePicker(e, "start")
                      },
                      openPickerIcon: () => <CalendarTodayIcon />
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <Autocomplete
                  inputValue={companyRole.companyRolename || ""}
                  open={selectCompanyRole}
                  options={companyRoles} // Array of strings
                  fullWidth
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    if (option?.companyRolename) {
                      return option?.companyRolename;
                    }
                    return option?.companyRolename;
                  }}
                  renderOption={(props, option) => <li {...props}>{option?.companyRolename}</li>}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="companyRole"
                      onChange={onCompanyrolechange}
                      label={TEXT_COMPANY_ROLE}
                    />
                  )}
                  onChange={(event, newValue) => onCompanyroleselect(event, newValue)}
                  disabled={
                    typeof selectedProject?.projectCompanyRoleId === "undefined" ||
                    selectedProject?.projectCompanyRoleId === 0
                      ? false
                      : true
                  }
                  clearOnBlur={true}
                  freeSolo
                  clearIcon={<CloseIcon onClick={(e) => onClearcompanyrole(e)} />}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    enableAccessibleFieldDOMStructure={false}
                    maxDate={dayjs()}
                    openTo="year"
                    value={information?.endDate ? dayjs(information.endDate) : null}
                    onChange={onEnddatechange}
                    open={openEnddate}
                    onOpen={() => !information?.present && setOpenenddate(true)} // Prevent opening when disabled
                    onClose={() => setOpenenddate(false)}
                    label={information?.present ? "" : TEXT_END_DATE}
                    views={["year", "month"]} // Show only Month & Year
                    className="timesheet-picker"
                    format="MMM YYYY"
                    name="endDate"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "medium",
                        error: false,
                        placeholder: TEXT_MONTH_YEAR,
                        InputLabelProps: { shrink: true },
                        onClick: (e) => {
                          if (information?.present) {
                            e.stopPropagation(); // Prevents event from propagating
                          } else {
                            setOpenenddate(true);
                          }
                        },
                        onFocus: (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }
                      },
                      inputAdornment: {
                        position: "start"
                      },
                      openPickerButton: {
                        onClick: (e) => handleTogglePicker(e, "end")
                      },
                      openPickerIcon: () => <CalendarTodayIcon />
                    }}
                    disabled={information?.present}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <Autocomplete
                  inputValue={role?.roleName || ""}
                  open={selectRole}
                  options={roles} // Array of strings
                  fullWidth
                  style={{ marginBottom: "15px" }}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    if (option?.roleName) {
                      return option?.roleName;
                    }
                    return option?.roleName;
                  }}
                  filterOptions={(options, params) => {
                    let inputValue = params.inputValue || "";

                    // Apply regex: remove leading non-alphanumeric characters
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");

                    const filtered = filter(options, {
                      ...params,
                      inputValue // pass the cleaned value
                    });

                    const isExisting = options.some((option) => inputValue === option?.roleName);

                    if (inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue,
                        roleName: `${BUTTON_ADD} "${inputValue}"`
                      });
                    }

                    return filtered;
                  }}
                  renderOption={(props, option) => <li {...props}>{option?.roleName}</li>}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="roleName"
                      onChange={onRolechange}
                      label={TEXT_TITLE_ROLE}
                    />
                  )}
                  onChange={(event, newValue) => onRoleselect(event, newValue)}
                  clearOnBlur={true}
                  freeSolo
                  clearIcon={<CloseIcon onClick={(e) => onClearRole(e)} />}
                />
                <Autocomplete
                  inputValue={trade?.tradeName || ""}
                  open={selectTrade}
                  options={trades} // Array of strings
                  fullWidth
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    if (option?.tradeName) {
                      return option?.tradeName;
                    }
                    return option?.tradeName;
                  }}
                  filterOptions={(options, params) => {
                    let inputValue = params.inputValue || "";

                    // Clean leading non-alphanumeric characters
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");

                    const filtered = filter(options, {
                      ...params,
                      inputValue
                    });

                    const isExisting = options.some((option) => inputValue === option?.tradeName);

                    if (inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue,
                        tradeName: `${BUTTON_ADD} "${inputValue}"`
                      });
                    }

                    return filtered;
                  }}
                  renderOption={(props, option) => <li {...props}>{option?.tradeName}</li>}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="trade"
                      onChange={onTradechange}
                      label={TEXT_TRADE}
                    />
                  )}
                  onChange={(event, newValue) => onTradeselect(event, newValue)}
                  clearOnBlur={true}
                  freeSolo
                  clearIcon={<CloseIcon onClick={(e) => onClearTrade(e)} />}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <TextField
                  size="medium"
                  type="text"
                  variant="outlined"
                  label={TEXT_LABEL_DESCRIPTION}
                  fullWidth
                  style={{ marginBottom: "5px" }}
                  minRows={4}
                  name="description"
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  value={information?.description}
                  onChange={(e) => onInformationchange(e)}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={information?.present}
                      onChange={(e) => onPresentchange(e)}
                      name="present"
                    />
                  }
                  label={TEXT_PRESENT}
                  className="present"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Typography style={{ color: BIGrey }}>{TEXT_PRODUCTS_IN_PROJECT}</Typography>
                <Typography style={{ margin: "10px 0px" }}>{TEXT_MATERIAL_INSTRUCTION}</Typography>
                <TextField
                  size="medium"
                  type="text"
                  variant="outlined"
                  fullWidth
                  style={{ marginBottom: "10px" }}
                  minRows={3}
                  onClick={() => onShowproducts()}
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea",
                      readOnly: true, // Prevent manual typing
                      startAdornment: (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            width: "1050em",
                            gap: "10px"
                          }}>
                          {selectedProducts.map((value) => (
                            <Chip
                              key={value?.productId}
                              label={value?.productName}
                              onDelete={() => onProductClick(value)}
                            />
                          ))}
                        </div>
                      )
                    }
                  }}
                />
                <Typography style={{ color: BIGrey }}>{TEXT_THIS_INFORMATION_CAN}</Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </Modal>
      <Addproducts
        from={"experience"}
        setSelectedproducts={setSelectedproducts}
        selectedProducts={selectedProducts}
        showProducts={showProducts}
        handleClose={() => setShowproducts(false)}
      />
    </>
  );
}

